import PropTypes from 'prop-types';
import React from 'react';
import { H4, TextArea, FormGroup, NumericInput } from '@blueprintjs/core';
import { withTranslation } from 'react-i18next';

class LexicalParams extends React.PureComponent {

  handleChange = (e) => {
    const newValue = e.target.value;
    this.props.onValueChange('lexicalClassesParamValues', 'lexicalClasses', newValue);
  }

  render() {
    const {t, value } = this.props;

    const cosSimilarityThreshold=value.cosSimilarityThreshold;

    return (
      <>



        <H4><u>{t('embeddingClassDefinition')}</u></H4>
        
        <FormGroup
          label={t('cosSimilarityThreshold')}
        >
          <NumericInput
            min={0} buttonPosition={null}
            value={cosSimilarityThreshold}
            onValueChange={(newValue) => this.props.onValueChange('lexicalClassesParamValues', 'cosSimilarityThreshold', newValue)}
          />
        </FormGroup>

        <H4><u>{t('lexicalClassDefinition')}</u></H4>
 
        <p>{t('oneClassPerLine')}</p>

        <TextArea
          onChange={this.handleChange}
          value={value.lexicalClasses}
          style={{'height': '300px', 'width': '600px'}}
        />
      </>
    );
  }
}

LexicalParams.propTypes = {
  value: PropTypes.object,
  onValueChange: PropTypes.func,

};

export default withTranslation()(LexicalParams);